import React from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import {chunk, debounce} from 'lodash';
import PropTypes from 'prop-types';
import SummaryFigure from 'common/components/summary-figure';
import {truncate} from 'common/utils/string-util';
import './index.scss';

const RESPONSIVE_THRESHOLD = 400;

export default class CardCallouts extends React.Component {
  static propTypes = {
    meta: PropTypes.object,
    style: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      isVerticalLayout: false,
    };
    this.ref = React.createRef();
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    this.observer = new ResizeObserver(debounce(this.handleResize, 250));
    this.observer.observe(this.ref.current);
  }

  componentWillUnmount() {
    this.observer.disconnect();
  }

  getCallouts(props, currency) {
    const {meta} = props;
    const {
      dataSummary,
      differenceColor,
      normalizerUnit,
      period,
      resolution,
      resource,
    } = meta;

    if (dataSummary) {
      // TODO: phase out the fallback meta.normalizerUnit, as
      // each summary figure needs its own normalizerUnit
      return dataSummary.map((summary, index) => (
        <SummaryFigure
          currency={currency}
          differenceColor={differenceColor}
          isDifference={summary.isDifference}
          key={`CardCallouts-SummaryFigure-${index}`}
          normalizerUnit={
            summary.hasOwnProperty('normalizerUnit')
              ? summary.normalizerUnit
              : normalizerUnit
          }
          period={period}
          resolution={resolution}
          resource={resource}
          timestamp={summary.timestamp || null}
          title={truncate(summary.label)}
          units={summary.units}
          value={summary.value}
        />
      ));
    }
    return [];
  }

  getCurrencyAndUnits(meta = {}) {
    let currency = null;
    if (meta.currency) {
      currency = meta.currency.symbol || meta.currency.id;
    }

    let units = null;
    if (meta.unit && meta.unit.shortName) {
      units = meta.unit.shortName;
    }

    return [currency, units];
  }

  render() {
    const {meta, style} = this.props;
    const {isVerticalLayout} = this.state;
    const [currency, units] = this.getCurrencyAndUnits(meta);
    const callouts = this.getCallouts(this.props, currency, units);
    return (
      <div
        className={'CardCallouts'}
        ref={this.ref}
        style={style || {paddingLeft: 17}}>
        {isVerticalLayout ? (
          <div className={'SummaryFigure--vertical'}>{callouts}</div>
        ) : (
          chunk(callouts, 3).map((row, rowIndex) => (
            <div
              className={`
                  arrange arrange--equal
                  ${rowIndex > 0 ? 'CardCallouts-Row' : ''}
                `}
              key={`CardCallouts-Row-${rowIndex}`}>
              {row.map((callout, index) => (
                <div
                  className={`
                      arrange-sizeFill
                      CardCallouts-Callout
                    `}
                  key={`CardCallouts-horizontal-${index}`}>
                  {callout}
                </div>
              ))}
            </div>
          ))
        )}
      </div>
    );
  }

  handleResize() {
    const node = this.ref.current;
    if (!node) {
      return;
    }
    const isVerticalLayout = node.offsetWidth < RESPONSIVE_THRESHOLD;
    if (this.state.isVerticalLayout !== isVerticalLayout) {
      this.setState({isVerticalLayout});
    }
  }
}
